import React, { useState } from 'react';
import { RotateCcw, Sparkles } from 'lucide-react';

const RADIUS = 44;
const CIRC = 2 * Math.PI * RADIUS;

const FILTERS = [
  { id: 'all', label: 'All tasks' },
  { id: 'todo', label: 'To do' },
  { id: 'done', label: 'Done' },
];

const ChecklistProgress = ({ percent, doneCount, total, filter, onFilter, onReset }) => {
  const [confirming, setConfirming] = useState(false);

  const handleReset = () => {
    if (!confirming) {
      setConfirming(true);
      setTimeout(() => setConfirming(false), 4000);
      return;
    }
    onReset();
    setConfirming(false);
  };

  return (
    <div
      className="bg-white rounded-2xl border border-[#EFE6E9] shadow-xl p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-8"
      data-testid="checklist-progress"
    >
      <div className="relative w-28 h-28 shrink-0 mx-auto md:mx-0">
        <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
          <circle cx="50" cy="50" r={RADIUS} fill="none" stroke="#F3ECEF" strokeWidth="8" />
          <circle
            cx="50" cy="50" r={RADIUS} fill="none" stroke="#DE92A9" strokeWidth="8" strokeLinecap="round"
            strokeDasharray={CIRC}
            strokeDashoffset={CIRC - (CIRC * percent) / 100}
            className="transition-all duration-700 ease-out"
          />
        </svg>
        <span
          className="absolute inset-0 flex items-center justify-center text-2xl tabular-nums"
          style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          data-testid="checklist-percent"
        >
          {percent}%
        </span>
      </div>

      <div className="flex-1 text-center md:text-left">
        <p className="text-[10px] tracking-[0.3em] uppercase mb-2" style={{ color: '#DE92A9' }}>Your progress</p>
        <p className="text-xl md:text-2xl mb-1" style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }} data-testid="checklist-count">
          {doneCount} of {total} tasks ticked off
        </p>
        <p className="text-sm" style={{ color: '#757B7F' }}>
          {percent === 100 ? 'Everything is done. Go and get married!' : 'Saved automatically in this browser, so you can come back anytime.'}
        </p>

        <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mt-5">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              type="button"
              onClick={() => onFilter(f.id)}
              className={`text-xs tracking-[0.15em] font-semibold px-4 py-2 rounded-full border-2 transition-colors ${
                filter === f.id ? 'text-white border-[#DE92A9]' : 'text-[#2C2C2C] border-[#EFE6E9] hover:border-[#E8AABC]'
              }`}
              style={filter === f.id ? { backgroundColor: '#DE92A9' } : undefined}
              data-testid={`checklist-filter-${f.id}`}
            >
              {f.label.toUpperCase()}
            </button>
          ))}
          <button
            type="button"
            onClick={handleReset}
            className="inline-flex items-center gap-1.5 text-xs tracking-[0.15em] font-semibold px-4 py-2 rounded-full transition-colors hover:text-[#C9758F]"
            style={{ color: confirming ? '#C9758F' : '#A0978A' }}
            data-testid="checklist-reset-btn"
          >
            {confirming ? <Sparkles size={13} /> : <RotateCcw size={13} />}
            {confirming ? 'TAP AGAIN TO CONFIRM' : 'START OVER'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChecklistProgress;
